import { render, staticRenderFns } from "./no-rows-overlay.vue?vue&type=template&id=5e479df4&scoped=true"
import script from "./no-rows-overlay.vue?vue&type=script&lang=ts"
export * from "./no-rows-overlay.vue?vue&type=script&lang=ts"
import style0 from "./no-rows-overlay.vue?vue&type=style&index=0&id=5e479df4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e479df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e479df4')) {
      api.createRecord('5e479df4', component.options)
    } else {
      api.reload('5e479df4', component.options)
    }
    module.hot.accept("./no-rows-overlay.vue?vue&type=template&id=5e479df4&scoped=true", function () {
      api.rerender('5e479df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ag-grid-table/overlay-types/no-rows-overlay.vue"
export default component.exports